export class OrderConfirmationUrlGenerator {
    constructor(
        private _partialUrl: string
    ) { }

    public getUrl(): string {
        return window.location.origin + this._partialUrl;
    }
}
